import { Link } from 'react-router';
import type { CollectionType } from '@/types/types_collection';
import { experienceRegionLabels } from '@/types/types_experience';

interface CollectionCardProps {
  collection: CollectionType;
}

/** A card for a collection (a curated group of experiences) in the public catalog grid. */
export function CollectionCard({ collection }: CollectionCardProps) {
  return (
    <Link
      to={`/collections/${collection.id}`}
      className='tw:group tw:flex tw:flex-col tw:overflow-hidden tw:border tw:border-ed-gold/30 tw:bg-white tw:transition-shadow tw:hover:shadow-xl'
    >
      <div className='tw:relative tw:aspect-[4/3] tw:overflow-hidden'>
        <img
          src={collection.heroImage}
          alt={collection.name}
          loading='lazy'
          className='tw:h-full tw:w-full tw:object-cover tw:transition-transform tw:duration-700 tw:group-hover:scale-105'
        />
        <span className='tw:absolute tw:left-4 tw:top-4 tw:bg-ed-gold tw:px-3 tw:py-1 tw:text-[0.65rem] tw:tracking-[0.2em] tw:uppercase tw:text-ed-black'>
          Collection
        </span>
      </div>

      <div className='tw:flex tw:flex-1 tw:flex-col tw:p-6'>
        <p className='tw:text-xs tw:tracking-[0.2em] tw:uppercase tw:text-ed-gold'>{collection.subtitle}</p>
        <h3 className='tw:mt-2 tw:font-serif tw:text-2xl tw:leading-tight tw:text-ed-black'>{collection.name}</h3>
        {/* The collection's descriptions were dropped from the model; the spacer
            keeps the region/location footer pinned to the bottom of the card. */}
        <div className='tw:flex-1' />
        <div className='tw:mt-5 tw:border-t tw:border-ed-black/10 tw:pt-4 tw:text-sm tw:text-ed-umber'>
          {experienceRegionLabels[collection.region]} · {collection.location}
        </div>
      </div>
    </Link>
  );
}
